import React from "react";
import styles from "./index.module.scss";
import Logo from "@src/components/Logo";
import { useNavigate } from "react-router-dom";
import Button from "@src/components/Button";
import img from "./assets/img.png";
import { isAndroid, isIOS } from "@src/lib/utils";
const title = "Get the Primus app to verify your data";

export default () => {
  const navigate = useNavigate();
  const onLogoClick = () => {
    navigate("/");
  };
  const onClickInstall = () => {
    if (isAndroid()) {
      window.open(
        "https://play.google.com/store/apps/details?id=xyz.primuslabs.primusapp"
      );
    } else if (isIOS()) {
      // TODO
    }
  };
  return (
    <div className={styles.root}>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          <div className={styles.logoWrapper}>
            <Logo
              onClick={onLogoClick}
              fontColor={"#FD4C00"}
              iconColor={"#fff"}
            />
          </div>

          <div className={styles.title}>{title}</div>
          <Button className={styles.button} isDark onClick={onClickInstall}>
            Install Now
          </Button>
          <img className={styles.img} src={img} />
        </div>
      </div>
    </div>
  );
};
